import { Component, OnInit, HostBinding, ChangeDetectorRef } from '@angular/core';
import { TemplatesModalComponent } from '../templates-modal/templates-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkspaceServiceService } from '../../../services/workspace-service.service';
import { WolfieContextMenuService } from '../../../services/wolfie-context-menu/wolfie-context-menu.service';

@Component({
  selector: 'mobile-templates-modal',
  template: require('./mobile-templates-modal.component.html'),
  styles: [require('./mobile-templates-modal.component.css')]
})
export class MobileTemplatesModalComponent extends TemplatesModalComponent
{
  @HostBinding('class.horizontal')
  get horizontal()
  {
    return this.workspaceService.data.horizontalMode;
  }

  constructor(public activeModal: NgbActiveModal, public modalService: NgbModal, public workspaceService: WorkspaceServiceService, public contextMenuService: WolfieContextMenuService) 
  {
    super(activeModal, modalService, workspaceService);
  }

  initScroll(nativeElement: any)
  {

  }

  setTemplate()
  {
    this.contextMenuService.hide();
    super.setTemplate();
  }
}
